// Client-safe error reporter used by app/error.tsx and app/global-error.tsx.
// Sentry is loaded lazily and ONLY when NEXT_PUBLIC_SENTRY_DSN is configured,
// so the SDK stays out of the client bundle for deployments without Sentry.
// openspec: iso27001-soc2-readiness task 1.4

export function reportError(error: unknown, context?: Record<string, unknown>): void {
  console.error('[app-error]', error, context ?? '')
  if (!process.env.NEXT_PUBLIC_SENTRY_DSN) return
  import('@sentry/nextjs')
    .then((Sentry) => {
      Sentry.captureException(error, context ? { extra: context } : undefined)
    })
    .catch(() => {
      /* reporting is best-effort */
    })
}
